import { Parser } from "./ast";

export function buildAst(dependencies) {
  const expression = dependencies.map((v) => {
    v = v[0] === "{" ? JSON.parse(v) : v;
    if (v === "||") {
      return "or";
    }
    if (v === "&&") {
      return "and";
    }
    return v?.inputId !== undefined ? v.inputId : v;
  });

  const parser = new Parser(expression);
  const ast = parser.parse();
  return ast;
}

export function getOperator(inputId, index, ast) {
  if (!ast) {
    return null;
  }

  if (
    (ast.left &&
      ast.left.node.index === index &&
      ast.left.node.value === inputId) ||
    (ast.right &&
      ast.right.node.index === index &&
      ast.right.node.value === inputId)
  ) {
    return ast.node?.value || "and";
  }
  const left = getOperator(inputId, index, ast.left);
  if (left) {
    return left;
  }
  const right = getOperator(inputId, index, ast.right);
  if (right) {
    return right;
  }
  return null;
}
